import { BlogEntity, BlogHighlight } from '../../types/blog.types';

// The highlights worth sending: trimmed, the empty rows dropped. None at all
// is null, which is also what clears them.
const filledHighlights = (rows: BlogHighlight[] | null | undefined) => {
  const filled = (rows ?? [])
    .map(({ value, label }) => ({ value: value.trim(), label: label.trim() }))
    .filter(({ value, label }) => value || label);
  return filled.length ? filled : null;
};

/** A highlight with only its value or only its label; the backend wants both. */
export const hasHalfHighlight = (rows: BlogHighlight[] | null | undefined) =>
  (rows ?? []).some(({ value, label }) => !value.trim() !== !label.trim());

/**
 * The form data's `blog` part. A blog post sends its client and highlights
 * as null: the backend keeps them when a case study turns back into a blog
 * post unless it is told to clear them.
 */
export const blogPayload = (blog: Partial<BlogEntity>) => {
  const caseStudy = blog.type === 'caseStudy';

  return {
    ...blog,
    type: blog.type ?? 'blog',
    client: caseStudy ? blog.client?.trim() || null : null,
    highlights: caseStudy ? filledHighlights(blog.highlights) : null,
  };
};
